import { render, staticRenderFns } from "./FeEditor.vue?vue&type=template&id=0cd4a764&scoped=true&"
import script from "./FeEditor.vue?vue&type=script&lang=js&"
export * from "./FeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd4a764",
  null
  
)

export default component.exports